import { Attrs, MinzeElement } from 'minze'
import { Locale } from '../../modules/locale'

Locale.getInstance().registerKeySet('fr', 'lvcBreadcrumb', {
  home: 'Accueil',
})
Locale.getInstance().registerKeySet('en', 'lvcBreadcrumb', {
  home: 'Home',
})

interface LvcBreadcrumbItem {
  title: string
  url: string
}

export interface LvcBreadcrumb {
  items: string
}

export class LvcBreadcrumb extends MinzeElement {
  attrs: Attrs = [['items', []]]
  parsedItems: LvcBreadcrumbItem[] = []
  static observedAttributes = ['items']

  onReady = () => {
    this.parsedItems = JSON.parse(decodeURIComponent(this.items))
    this.rerender()
  }

  html = () => `
    <ul class="breadcrumb">
      <li class="breadcrumb-home">
        <lvc-home-icon></lvc-home-icon>
        <a href="/">${Locale.getKey('lvcBreadcrumb.home')}</a>
      </li>
      ${this.parsedItems
        .map((item, index, items) => {
          if (index + 1 === items.length) {
            return `
            <lvc-chevron-right-icon></lvc-chevron-right-icon>
            <li>${item.title}</li>
          `
          } else {
            return `
            <lvc-chevron-right-icon></lvc-chevron-right-icon>
            <li><a href="${item.url}">${item.title}</a></li>
          `
          }
        })
        .join('')}
    </ul>
  `

  css = () => `
    :host {}

    ul.breadcrumb {
      display: flex;
      align-items: center;
      gap: 12px;
      margin: 0;
      padding: 0;
      list-style: none;
      color: #1E007D;
    }

    ul.breadcrumb lvc-chevron-right-icon {
      display: flex;
    }

    ul.breadcrumb li.breadcrumb-home {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    ul.breadcrumb li {
      margin: 0;
      padding: 0;
      font-size: 0.875em;
      font-weight: 500;
      line-height: 1;
    }

    ul.breadcrumb li:last-child {
      font-weight: 800;
    }

    ul.breadcrumb li a {
      color: #1E007D;
      text-decoration: none;
    }

    ul.breadcrumb li a:hover {
      text-decoration: underline;
      text-underline-offset: 4px;
    }
  `
}
